var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"info-list-box"},_vm._l((_vm.infoList),function(item,index){return _c('li',{key:index},[_c('a',{on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(_vm._s(item.newsTitle))]),(!_vm.hiddenDate)?_c('span',[_vm._v("["+_vm._s(item.date)+"]")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }